import { useQuery } from "@tanstack/react-query";
import { useAuthenticatedFetch } from "@/hooks/use-authenticated-fetch";
import { collectionKeys } from "@/lib/query-keys";
import type { ReportCollection, ReportStatus } from "@/types/api";

const IN_PROGRESS: ReportStatus[] = ["PENDING", "PROCESSING"];

/**
 * One collection, polled while its newest export is still running.
 *
 * Polling stops the moment the export settles, so a page left open on a
 * finished report costs nothing.
 */
export function useCollection(projectId: string, collectionId: string) {
  const fetchWithAuth = useAuthenticatedFetch();

  return useQuery({
    queryKey: collectionKeys.detail(projectId, collectionId),
    queryFn: () =>
      fetchWithAuth<ReportCollection>(
        `/reports/3.0/projects/${projectId}/collections/${collectionId}/`,
      ),
    refetchInterval: (query) => {
      const status = query.state.data?.latest_export?.status;
      return status && IN_PROGRESS.includes(status) ? 3_000 : false;
    },
    staleTime: 10_000,
  });
}
